import React, { useEffect, useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './pages/Home';
import ServicesPage from './pages/Services';
import BlogPage from './pages/Blog';
import StartProject from './components/StartProject';
import HeroPortfolio from './components/HeroPortfolio';

const App = () => {
  const [cursorPos, setCursorPos] = useState({ x: -200, y: -200 });
  const location = useLocation();

  // Mouse cursor lighting follower
  useEffect(() => {
    const handleMouseMove = (e) => {
      setCursorPos({ x: e.clientX, y: e.clientY });
    };
    window.addEventListener('mousemove', handleMouseMove, { passive: true });
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  // Global 4D Scroll Reveal Observer
  useEffect(() => {
    let observer;
    const raf = requestAnimationFrame(() => {
      observer = new IntersectionObserver(
        (entries) => entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add('active'); }),
        { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
      );
      document.querySelectorAll('.reveal-left, .reveal-right, .reveal-depth')
              .forEach((el) => observer.observe(el));
    });
    return () => { cancelAnimationFrame(raf); if (observer) observer.disconnect(); };
  }, [location]);

  return (
    <div className="App relative text-[#F5F3EF]" style={{ backgroundColor: '#021810', minHeight: '100vh' }}>

      {/* Cursor Gold Glow */}
      <div
        className="pointer-events-none fixed w-80 h-80 rounded-full z-30 hidden md:block"
        style={{
          left: `${cursorPos.x}px`,
          top:  `${cursorPos.y}px`,
          transform: 'translate(-50%, -50%)',
          background: 'radial-gradient(circle, rgba(212,175,55,0.09) 0%, rgba(212,175,55,0.02) 45%, transparent 70%)',
          transition: 'left 0.06s linear, top 0.06s linear',
        }}
      />

      <Routes>
        <Route path="/"              element={<HomePage />} />
        <Route path="/services"      element={<ServicesPage />} />
        <Route path="/start-project" element={<StartProject />} />
        <Route path="/portfolio"     element={<HeroPortfolio />} />
        <Route path="/blog"          element={<BlogPage />} />
      </Routes>
    </div>
  );
};

export default App;
